// ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import PopupService from '../PopupService';

/**
 * Get user type from session storage
 */
const getUserType = () => sessionStorage.getItem('user_type');

/**
 * Check if user is logged in
 */
const isLoggedIn = () => !!localStorage.getItem('mr_token'); // use the same key your login sets

/**
 * ProtectedRoute component
 */
const ProtectedRoute = ({ allowed = [], children }) => {
  const userType = getUserType();

  if (!isLoggedIn()) {
    if (window.location.pathname !== '/login') {
      PopupService.getInstance().showMessage(
        'You must be logged in to access this page.',
        false
      );
    }
    return <Navigate to="/login" replace />;
  }
  const hasAccess =
     allowed.length === 0 ||
     allowed.includes('ALL_PRIV') ||
     userType === 'ALL_PRIV' ||userType === 'RESTRICTED'|| userType === 'ADMIN'
     allowed.includes(userType);

	 if (!hasAccess) {
	    PopupService.getInstance().showMessage(
	      'You are not authorized to access this page: ' + (userType || 'Unknown'),
	      false
	    );
	    return <Navigate to="/home" replace />;
	  }

  return children;
};

export default ProtectedRoute;
